import { annotate, annotationGroup } from 'rough-notation';

export default config => ({
    config,

    showAnnotation() {
        annotate(this.$el, this.config).show();
    },

    showAnnotationGroup() {
        annotationGroup(
            [...this.$el.querySelectorAll('.annotation-group-item')]
                .map((el, index) => annotate(el, this.config ?? {}))
        ).show();
    }
});
